<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">标题：</span>
        </div>
        <el-input v-model="formData.header" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">
            视频ID<el-tooltip class="item" effect="dark" content="暂只支持优酷视频ID" placement="top" style="margin: 0 5px">
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.videoUrl" size="small" style="width: 280px" />
      </div>
      <!--<div class="form-line">-->
      <!--<div class="textBox">-->
      <!--<b class="red">*</b>-->
      <!--<span class="line-text">宣传视频：</span>-->
      <!--</div>-->

      <!--<el-upload-->
      <!--class="upload-demo"-->
      <!--drag-->
      <!--ref="uploadVideo"-->
      <!--:action="uploadAction"-->
      <!--:auto-upload="false"-->
      <!--:headers="uploadHeaders"-->
      <!--:data="formData"-->
      <!--:before-upload="beforeUploadVideo"-->
      <!--:on-success="uploadVideoSuccess"-->
      <!--:on-error="uploadVideoError"-->
      <!--:limit="1">-->
      <!--<i class="el-icon-upload"></i>-->
      <!--<div class="el-upload__text">将视频拖拽至虚线框内或<em>点击上传</em></div>-->
      <!--<div class="el-upload__text">文档只支持doc, docx格式</div>-->
      <!--</el-upload>-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" :rows="3" v-model="formData.content" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/yqVideo'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'modify-yq-video',
    data () {
      return {
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '视频宣传'
        }],
        mainTitle: '修改宣传视频',
        subheading: '修改园区宣传视频，可在大数据平台上展示',
        formData: {
          code: '',
          header: '',
          videoUrl: '',
          memo: '',
        },
        uploadHeaders: {
          token: '',
          'yq-app-code': ''
        },
        uploadAction: api.addyqVideo
      }
    },
    created () {
      this.uploadHeaders.token = bus.global.token
      this.uploadHeaders['yq-app-code'] = bus.global.yqCode

      this.formData.header = this.$route.query.header
      this.formData.videoUrl = this.$route.query.videoUrl
      this.formData.memo = this.$route.query.memo
      this.formData.code = this.$route.params.id
    },
    methods: {
      toyqVideoManagementPage () {
        this.$router.push({
          name: 'yq-video-management'
        })
      },
      // 确认
      confirm () {
        if (!this.formData.header) {
          nError('请输入宣传标题')
          return false
        }
        if (!this.formData.videoUrl) {
          nError('请输入视频ID')
          return false
        }
        this.$axios.post(api.updateyqVideo, this.formData)
          .then(res => {
            nSuccess('修改成功')
            this.toyqVideoManagementPage()
          })
          .catch(errorHandler('修改失败'))
      },
      // 上传视频
      uploadVideo () {
        this.$refs.uploadVideo.submit()
      },
      beforeUploadVideo () {
        if (!this.formData.header) {
          nError('请输入宣传标题')
          return false
        }
      },
      // 上传成功
      uploadVideoSuccess () {
        this.$refs.uploadVideo.clearFiles()
        this.toyqVideoManagementPage()
      },
      // 上传失败
      uploadVideoError (err) {
        nError('上传失败')
      },

      cancel () {
        this.toyqVideoManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/ResourceCenter/ParkVideoManagement/ModifyParkVideo.vue